import { Component, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { pluck } from "rxjs/operators";
import { Dictionary } from "src/app/store/models/common_types";
import { ReportingPagesDataService } from "../reporting-pages-data.service";
import { ReportingPagesService } from "../reporting-pages.service";
import { ReportingGridWrapperComponent } from "../reporting-grid-wrapper/reporting-grid-wrapper.component";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import dayjs from "dayjs";
import { VAIconRegistryService, fileExcel } from "@va/core-library/icons";

@Component({
  selector: "app-reporting-model-library",
  templateUrl: "./reporting-model-library.component.html",
  styleUrls: ["./reporting-model-library.component.scss"],
  host: { class: "model-page-component" },
})
export class ReportingModelLibraryComponent {
  showSearch = true;
  userId: number;
  listOfOption: Array<{ label: string; value: string }> = [
    { label: "a1", value: "a" },
    { label: "b1", value: "b" },
    { label: "c1", value: "c" },
  ];
  watchlistData;
  selectedWatchlist;
  showGridFilters: boolean;
  page: string;
  columns: {
    columnFields: Array<Dictionary<any>>;
    columnsData: Array<Dictionary<any>>;
    widthConfig: Array<string>;
    setWidth?: boolean;
    columnVisiblityChange?: boolean;
  };
  gridUrl: string;
  sortKey: string;
  exportKey: string;
  exportColumns: Array<any>;
  @ViewChild(ReportingGridWrapperComponent)
  gridWrapperComp: ReportingGridWrapperComponent;
  globalSearchVal: string;
  columnData = {
    headerText: "Selected",
    list: [],
  };
  originalColFields: Array<any>;
  originalColData: Array<any>;
  originalColWidth: Array<any>;
  isModalVisible = false;
  subscription: Subscription;
  historicalModelData: Dictionary<any> = {};
  currentModalData: any;
  coveragestatusList: Array<any> = [];
  constructor(
    private store: Store<AppState>,
    private dataService: ReportingPagesDataService,
    private service: ReportingPagesService,
    private route: ActivatedRoute,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.columns = {
      columnFields: [],
      columnsData: [],
      widthConfig: [],
      setWidth: true,
      columnVisiblityChange: false,
    };
    store
      .select("globalHeader")
      .pipe(pluck("globalSettings"))
      .subscribe((data: any) => {
        this.userId = data.userId;
      });

    this.subscription = this.service.archiveMethod$.subscribe((data) => {
      this.showModal(data);
    });
    this.iconRegistry.registerIcons([fileExcel]);
  }
  getCoverageStatus() {
    this.dataService.getCoverageStatus().subscribe((response) => {
      this.coveragestatusList.push({ val: "", display: "[All]" });
      response.forEach((item) => {
        this.coveragestatusList.push({
          val: item.toLowerCase(),
          display: item,
        });
      });
    });
  }
  ngOnInit() {
    this.getCoverageStatus();
    this.exportKey = "MODEL_PAGE";
    this.service.logUserOnRedirection("MODEL_PAGE", {});
    this.route.params.subscribe(() => {
      this.page = "models";
      this.gridUrl = "api/getallmodels/?";
      //columns = ['modeldate', 'ticker','bloombergcode', 'companyname', 'sector', 'industry', 'source', 'waterfrontBadge', 'analyst', 'size','historicalModelLink','status', 'views'];
      const columnFields = [
        {
          field: "modeldate",
          renderer: null,
        },
        {
          field: "ticker",
          renderer: "link",
        },
        {
          field: "bloombergcode",
          renderer: "link",
        },
        {
          field: "companyname",
          renderer: "link",
        },
        {
          field: "sectorname",
          renderer: "link",
        },
        {
          field: "industryname",
          renderer: "link",
        },
        {
          field: "source",
          renderer: "link",
        },

        {
          field: "waterfrontBadge",
          renderer: "icon-link",
        },
        {
          field: "analyst",
          renderer: "link",
        },
        {
          field: "filesize",
          renderer: "report-model-link",
        },
        {
          field: "historicalModelLink",
          renderer: "icon-link",
        },
        {
          field: "coveragestatus",
          renderer: null,
        },
        // {
        //   field: "views",
        //   renderer: "report-view-link"
        // }
      ];
      const columnsData = [
        [
          {
            children: 1,
            header: "Model Date",
            sortKey: "modeldate",
            showSort: true,
            showFilter: false,
          },
          {
            children: 1,
            header: "Ticker",
            sortKey: "ticker",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Bloomberg Ticker",
            sortKey: "bloombergcode",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Company",
            sortKey: "companyname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Sector",
            sortKey: "sectorname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Industry",
            sortKey: "industryname",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Source",
            sortKey: "source",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "WF",
            sortKey: "waterfrontBadge",
            showSort: false,
            showFilter: true,
            filterType: "select",
            filterSelectValues: [
              { val: "", display: "[All]" },
              { val: "yes", display: "Yes" },
              { val: "no", display: "No" },
            ],
            currentValue: "",
          },
          {
            children: 1,
            header: "Analyst",
            sortKey: "analyst",
            showSort: true,
            showFilter: true,
            filterType: "text",
          },
          {
            children: 1,
            header: "Model",
            sortKey: "filesize",
            showSort: false,
            showFilter: false,
          },
          {
            children: 1,
            header: "Archive",
            sortKey: "historicalModelLink",
            showSort: false,
            showFilter: false,
          },
          {
            children: 1,
            header: "Coverage Status",
            sortKey: "coveragestatus",
            showSort: false,
            showFilter: true,
            filterType: "select",
            filterSelectValues: this.coveragestatusList,
            currentValue: "",
          },
          // {
          //   header: "Views",
          //   sortKey: "views",
          //   showSort: false,
          //   showFilter: false
          // }
        ],
      ];
      this.sortKey = "modeldate";
      this.columns.columnFields = columnFields;
      this.columns.columnsData = columnsData;

      this.columns.widthConfig = [
        "120px", //modeldate
        "150px", //ticker
        "150px", //bloomber ticker
        "170px", //company
        "170px", //sector
        "170px", //industry
        "170px", //source
        "120px", //waterfrontBadge
        "170px", //analyst
        "110px", //size
        "80px", // archive
        "140px", // status
        //"280px" // views
      ];
      this.originalColFields = columnFields.slice();
      this.originalColData = columnsData[0].slice();
      this.originalColWidth = this.columns.widthConfig.slice();
      this.exportColumns = columnsData[0]
        .map((d) => {
          return d.sortKey;
        })
        .filter((column) => {
          return (
            column !== "waterfrontBadge" && column !== "historicalModelLink"
          );
        });

      this.dataService
        .getSelectedModelColumns()
        .subscribe((selectedColumns) => {
          const disabledCheckbox = ["modeldate", "filesize"];
          if (selectedColumns.jsonData.columns.length === 0) {
            selectedColumns.jsonData.columns = this.originalColData.map(
              (item) => {
                return item.sortKey;
              },
            );
          }
          selectedColumns.jsonData.columns =
            selectedColumns.jsonData.columns.concat(
              disabledCheckbox.filter(
                (item) => selectedColumns.jsonData.columns.indexOf(item) < 0,
              ),
            );
          const cols = selectedColumns.jsonData.columns.map((n) => {
            if (n === "size") return "filesize";
            return n;
          });

          this.columnData.list = this.originalColData.map((item) => {
            return {
              label: item.header === "WF" ? "Badge" : item.header,
              value: item.sortKey,
              checked:
                cols.includes(item.sortKey) ||
                disabledCheckbox.includes(item.sortKey),
              disabled: disabledCheckbox.includes(item.sortKey) ? true : false,
            };
          });
          this.columnDataChange(cols, true);
        });
    });
  }

  selectWatchlistFunc(selectedWatchlist) {
    this.selectedWatchlist = selectedWatchlist;
  }

  toggleFilter(ev) {
    this.showGridFilters = ev.showFilters;
  }

  onSearch(val) {
    this.globalSearchVal = val;
  }

  handleOk(): void {
    this.isModalVisible = false;
  }

  handleCancel(): void {
    this.isModalVisible = false;
  }
  showModal(params): void {
    this.dataService.getHistoricalModalData(params).subscribe((res) => {
      this.historicalModelData.data = res.data.map((modelRevision) => {
        modelRevision.event_date = dayjs(modelRevision.event_date).format(
          "YYYY-MM-DD",
        );
        return modelRevision;
      });
      this.historicalModelData.source_details = res.source_details;
      this.isModalVisible = true;
    });
    this.currentModalData = params;
  }
  modelDownloadClick(transactionId, source) {
    const params = {
      companyId: this.currentModalData.companyId,
      pg: this.currentModalData.pg,
      source: source,
      transactionId: transactionId,
    };
    this.service.modelDownloadClick(params);
  }
  onReloadGrid() {
    this.gridWrapperComp.gridReload();
  }
  columnDataChange(event, firstCall) {
    const selectedColumns = event;
    let columnFields = [];
    const columnData = [],
      colWidths = [];
    for (let index = 0; index < selectedColumns.length; index++) {
      const element = selectedColumns[index];
      columnFields.push(
        this.originalColFields.filter((val, i) => {
          if (val.field === element) {
            columnData.push(this.originalColData[i]);
            colWidths.push(this.originalColWidth[i]);
            return val;
          }
          return null;
        })[0],
      );
    }
    columnFields = columnFields.filter(
      (val) => val !== null && val !== undefined,
    );
    const gridWidths = colWidths.map((a) => {
      return parseInt(a);
    });
    const gridWidth = gridWidths.reduce((a, b) => {
      return a + b;
    }, 0);
    if (
      document.getElementsByClassName("grid-container")[0].clientWidth >=
      gridWidth
    ) {
      colWidths[colWidths.length - 1] = "auto";
    }
    this.exportColumns = columnData
      .map((d) => {
        return d.sortKey;
      })
      .filter((column) => {
        return column !== "waterfrontBadge" && column !== "historicalModelLink";
      });
    this.columns = {
      columnFields: columnFields,
      columnsData: [columnData],
      widthConfig: colWidths,
      setWidth: true,
      columnVisiblityChange: firstCall === true ? false : true,
    };
    if (!firstCall)
      this.dataService
        .updateSelectedColumnsInModels(selectedColumns)
        .subscribe();
  }
}
